// Two-letter initials for avatar fallbacks. Strips the email domain and splits
// on separators so "jane.doe@dotlumen.com" -> "JD", "admin" -> "AD".
export function initialsOf(name: string | null | undefined, fallback: string): string {
  const src = (name || fallback || '').trim();
  if (!src) return '?';
  const parts = src.replace(/@.*/, '').split(/[.\s_-]+/).filter(Boolean);
  const letters = parts.length >= 2 ? parts[0][0] + parts[1][0] : src.slice(0, 2);
  return letters.toUpperCase();
}
